// arise-frontend/src/utils/safeRedirect.js
// Open-redirect guard for post-login navigation. Accepts only an internal path
// that starts with exactly one "/" (rejects "//host", "/\host", absolute URLs,
// whitespace/control characters) and never bounces back to /login or /register.
const DEFAULT_TARGET = '/analyze';
const AUTH_PATHS = new Set(['/login', '/register']);

export function safeRedirect(target, fallback = DEFAULT_TARGET) {
  if (typeof target !== 'string') return fallback;
  if (!/^\/(?![/\\])[\x21-\x7E]*$/.test(target)) return fallback;
  const path = target.split(/[?#]/)[0].replace(/\/+$/, '').toLowerCase() || '/';
  if (AUTH_PATHS.has(path)) return fallback;
  return target;
}
